import { Link } from "react-router-dom";
import { usePermission } from "@/auth/usePermission";
import { PageBanner } from "@/shared/components/PageBanner";

export function PlanningHomePage() {
  const canManage = usePermission("planning.manage");

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0" }}>
      <PageBanner
        title="پیش‌خوان برنامه‌ریزی تولید"
        subtitle="مدیریت برنامه جامع تولید (MPS)، نیازمندی‌های مواد (MRP) و کنترل ظرفیت ایستگاه‌های کاری"
        icon="🗓️"
       helpLink="/help/planning/planning-home" />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "1.5rem",
        }}
      >
        <Link
          to="/planning/master-schedules"
          className="brand-card-extand block"
          style={{ padding: "1.5rem", textDecoration: "none" }}
        >
          <div style={{ fontSize: "2.2rem", marginBottom: "0.75rem" }}>
            🗓️
          </div>
          <h3 style={{ fontSize: "1.1rem", fontWeight: "800", color: "#007270", marginBottom: "0.5rem" }}>
            برنامه جامع تولید (MPS)
          </h3>
          <p style={{ color: "var(--color-text-main)", fontSize: "0.85rem", margin: 0 }}>
            مشاهده دوره‌های برنامه‌ریزی تولید و {canManage ? "ایجاد برنامه جدید" : "سوابق"}
          </p>
        </Link>

        <Link
          to="/planning/mrp-runs"
          className="brand-card-extand block"
          style={{ padding: "1.5rem", textDecoration: "none" }}
        >
          <div style={{ fontSize: "2.2rem", marginBottom: "0.75rem" }}>
            ⚙️
          </div>
          <h3 style={{ fontSize: "1.1rem", fontWeight: "800", color: "#007270", marginBottom: "0.5rem" }}>
            اجراهای برنامه مواد (MRP)
          </h3>
          <p style={{ color: "var(--color-text-main)", fontSize: "0.85rem", margin: 0 }}>
            محاسبه و ارزیابی نیازهای مواد اولیه بر اساس برنامه‌های فعال
          </p>
        </Link>

        <Link
          to="/planning/capacity-check"
          className="brand-card-extand block"
          style={{ padding: "1.5rem", textDecoration: "none" }}
        >
          <div style={{ fontSize: "2.2rem", marginBottom: "0.75rem" }}>
            ⚖️
          </div>
          <h3 style={{ fontSize: "1.1rem", fontWeight: "800", color: "#007270", marginBottom: "0.5rem" }}>
            بررسی ظرفیت (Capacity)
          </h3>
          <p style={{ color: "var(--color-text-main)", fontSize: "0.85rem", margin: 0 }}>
            کنترل بار کاری و بررسی گلوگاه‌های ظرفیت ایستگاه‌ها
          </p>
        </Link>

        <Link
          to="/planning/capacity-profiles"
          className="brand-card-extand block"
          style={{ padding: "1.5rem", textDecoration: "none" }}
        >
          <div style={{ fontSize: "2.2rem", marginBottom: "0.75rem" }}>
            📊
          </div>
          <h3 style={{ fontSize: "1.1rem", fontWeight: "800", color: "#007270", marginBottom: "0.5rem" }}>
            پروفایل‌های ظرفیت
          </h3>
          <p style={{ color: "var(--color-text-main)", fontSize: "0.85rem", margin: 0 }}>
            پیکربندی و مشاهده نرخ تولید اسمی و سقف توان ماشینی
          </p>
        </Link>
      </div>
    </div>
  );
}
